import { render } from "./AppointmentBooking.vue?vue&type=template&id=5d108508&scoped=true"
import script from "./AppointmentBooking.vue?vue&type=script&lang=js"
export * from "./AppointmentBooking.vue?vue&type=script&lang=js"

import "./AppointmentBooking.vue?vue&type=style&index=0&id=5d108508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d108508"]])

export default __exports__